export const Order = {
    deliveryDate: null,
    description: '',
    eta: null,
    folio: '',
    id: null,
    isDelivery: false,
    item: '',
    statusId: null,
    supplierEmployeeId: null,
    supplierId: '',
    supplierVehicleColor: null,
    supplierVehicleId: null,
    userReceivedId: null,
    isValid: function () {
        const hasDate = this.deliveryDate !== null;
        const hasItem = typeof this.item === 'string' && this.item.trim().length > 0;
        const hasSupplier = typeof this.supplierId === 'string' && this.supplierId.trim().length > 0;
        return hasDate && hasItem && hasSupplier;
    },
    toRegister: function () {
        return {
            deliveryDate:
                this.deliveryDate === null
                    ? null
                    : typeof this.deliveryDate === 'number'
                        ? this.deliveryDate
                        : this.deliveryDate.getTime(),
            description: this.description && this.description.trim() !== '' ? this.description : null,
            id: this.id,
            folio: this.folio && this.folio.trim() !== '' ? this.folio : null,
            isDelivery: this.isDelivery,
            item: this.item,
            supplierId: this.supplierId,
        };
    },
    toUpdate: function () {
        return {
            deliveryDate:
                this.deliveryDate === null
                    ? null
                    : typeof this.deliveryDate === 'number'
                        ? this.deliveryDate
                        : this.deliveryDate.getTime(),
            description: this.description && this.description.trim() !== '' ? this.description : null,
            id: this.id,
            folio: this.folio && this.folio.trim() !== '' ? this.folio : null,
            isDelivery: this.isDelivery,
            item: this.item,
            supplier: {
                id: this.supplierId
            }
        };
    },
    set: function (data) {
        return {
            ...this,
            id: data.id,
            deliveryDate:data.deliveryDate,
            description: data.description,
            folio: data.folio,
            isDelivery: data.isDelivery,
            item: data.item,
            supplierId: data.supplier.id,
            statusId: data.status.id
        };
    },
};
